module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAYAAAD6S912AAAA7klEQVQ4jb3VMU/DMBCG4acklUB0QUECBgbERPkbSPz/AVZgY0BMoCJBEEOuIXWb0Dak35Tz53vj8yX2SLtOcYVJMv6Oezx35C5pglsUK7wivPRFIGsBnuMDjyu8GfZxgNfUHOEmzP/QbP5wiWkP0DQY9mLgC3kPYB6M3QEvRAlrxjVwDkmBGcYbxMOXXPYEZsFYWGHbR76Odt/l3sA+0Bo2OHDbTtcdToHbdnrYkpuAJrDEd8PriluBn37/z4dkFV3xOHKxWPIbjmyuInKXgE84Ux1L6+xlHnNPIhfVndLUIa5x7O+Ol3jBnepqBT8O7DuEED83aQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/images/deleteDisable.png
// module id = 201
// module chunks = 0